export const API_URL = 'https://aihub-api.buso.asia';

export const VITE_STRIPE_PUBLIC_KEY = 'pk_test_51Ib13qDxgEMKmPxXhaaMAsTiPQWw3IF9SIUMcpVQEJlRvoSJog5DLdCsWC66V8tOZPXrsGysxXIPXRIx0j4qRnNQ00OPbcZDc7'
